import { useScriptUmamiAnalytics, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const umamiAnalytics = useScriptUmamiAnalytics({"domains":["sosrestorationcrm.com"],"websiteId":"30228d37-618a-46a3-8089-52d172bc07a8"})
    return { provide: { $scripts: { umamiAnalytics } } }
  }
})